















import QErrors from "@/common/qErrors.vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qTextArea",
  components: { QErrors },
})
export default class qTextArea extends Vue {
  @PropSync("value", {
    required: true,
  })
  public valueSync;

  @Prop({
    default: false,
  })
  public required;

  @Prop({
    default: 20,
  })
  public rows;

  @Prop({
    type: String,
    required: true,
  })
  public name;

  @Prop({
    type: String,
    default: "",
  })
  public customClass;

  @Prop({
    type: String,
    default: "",
  })
  public placeholder;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  public errors;

  public clearError() {
    this.$emit("update:errors", { ...this.errors, ...{ [this.name]: [] } });
  }
}
